import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { IMAGEAPI } from "../../BackendConnections";
import {
  acceptConnectionRequestAction,
  fetchAcceptConnectionRequestsAction,
  fetchPendingConnectionRequestsAction,
  fetchPendingProfileRequestsAction,
  ignoreConnectionRequestAction,
  withDrawPedingConnectionAction,
  withDrawProfileConnectionAction,
  fetchPendingProfileConnectionsAction,
  acceptProfileConnectionAction,
  ignoreProfileConnectionAction,
} from "../../redux/actions/network/networkAction";
import HexaImage from "../utils/imgCards/HexaImage";
import Slider from "react-slick"; // Import Slider component
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp } from "react-icons/md";


export const ConnectionRequests = (props) => {
  const [data, setData] = useState({
    is_accept_connection: false,
    is_accept_profile_connection: false,
    is_pending_connections: false,
    is_pending_profile_connections: false,
  });
  // console.log(props);
  const [acceptConnection, setAcceptConnection] = useState([]);
  const [acceptProfileConnection, setAcceptProfileConnection] = useState([]);
  const [pendingConnection, setPendingConnection] = useState([]);
  const [profilePendingConnection, setProfilePendingConnection] = useState([]);
  const [myConnectionMore, setMyConnectionMore] = useState(false);

  // Define functions to handle removal of connection forms
  const handleRemoveFormAccept = (index) => {
    const values = [...acceptConnection];
    values.splice(index, 1);
    setAcceptConnection(values);
  };

  const handleRemoveFormConnection = (index) => {
    const values = [...pendingConnection];
    values.splice(index, 1);
    setPendingConnection(values);
  };

  const handleRemoveFormProfileAccept = (index) => {
    const values = [...acceptProfileConnection];
    values.splice(index, 1);
    setAcceptProfileConnection(values);
  };

  const handleRemoveFormProfile = (index) => {
    const values = [...profilePendingConnection];
    values.splice(index, 1);
    setProfilePendingConnection(values);
  };

  // Define functions to handle accepting and ignoring connection requests
  const handleAcceptConnectionChange = (index) => {
    const values = [...acceptConnection];
    const connection = values.splice(index, 1);
    setAcceptConnection(values);
    props.acceptConnectionRequest(connection[0].sender[0].id, connection);
    props.connectionAccepted();
  };

  const handleIgnoreConnectionChange = (index) => {
    const values = [...acceptConnection];
    const connection = values.splice(index, 1);
    setAcceptConnection(values);
    const request = {
      id: connection[0].sender[0].id,
    };
    props.ignoreConnectionRequest(request, connection);
  };
// Define functions to handle accepting and ignoring profile connection requests
const handleAcceptProfileConnectionChange = (index) => {
  const values = [...acceptProfileConnection];
  const connection = values.splice(index, 1);
  setAcceptProfileConnection(values);

  // Log the action to check its parameters
  console.log(fetchPendingProfileConnectionsAction(connection[0].id, connection));

  // Dispatch the action
  props.acceptProfileConnectionRequest(connection[0].id, connection);
};


  const handleIgnoreProfileConnectionChange = (index) => {
    const values = [...acceptProfileConnection];
    const connection = values.splice(index, 1);
    setAcceptProfileConnection(values);
    const request = {
      id: connection[0].sender[0].id,
    };
    props.ignoreProfileConnectionRequest(request, connection);
  };
// Define functions to handle withdrawing pending connection requests
  const handleWithdrawPendingChange = (index) => {
    const values = [...pendingConnection];
    const receiver = values.splice(index, 1);
    setPendingConnection(values);
    const data = {
      receiver: receiver[0]["id"],
    };
    props.withdrawPendingConnection(receiver, data);
  };

  const handleWithdrawProfilePendingChange = (index) => {
    const values = [...profilePendingConnection];
    const receiver = values.splice(index, 1);
    setProfilePendingConnection(values);
    const data = {
      receiver: receiver[0]["id"],
    };
    props.withdrawProfilePendingConnection(receiver[0]["id"], data);
  };
  // console.log(props);

  useEffect(() => {
    if (Object.keys(props.profile).length > 0) {
      if (
        props.acceptConectionRequests.length === 0 &&
        data.is_accept_connection === false
      ) {
        setData((prevState) => ({ ...prevState, is_accept_connection: true }));
        props.fetchAcceptConnectionRequests(props.profile.id);
      }

      if (
        props.pendingConnectionRequests.length === 0 &&
        data.is_pending_connections === false
      ) {
        setData((prevState) => ({
          ...prevState,
          is_pending_connections: true,
        }));
        props.fetchPendingConnectionRequests(props.profile.id);
      }

      if (
        props.acceptProfileConectionRequests.length === 0 &&
        data.is_accept_profile_connection === false
      ) {
        setData((prevState) => ({
          ...prevState,
          is_accept_profile_connection: true,
        }));
        props.fetchAcceptProfileConnections(props.profile.id);
      }

      if (
        props.pendingProfileRequests.length === 0 &&
        data.is_pending_profile_connections === false
      ) {
        setData((prevState) => ({
          ...prevState,
          is_pending_profile_connections: true,
        }));
        props.fetchPendingProfileRequests(props.profile.id);
      }

      if (props.acceptConectionRequests) {
        setAcceptConnection(props.acceptConectionRequests);
      }

      if (props.pendingConnectionRequests) {
        setPendingConnection(props.pendingConnectionRequests);
      }

      if (props.pendingProfileRequests) {
        setProfilePendingConnection(props.pendingProfileRequests);
      }

      if (props.acceptProfileConectionRequests) {
        setAcceptProfileConnection(props.acceptProfileConectionRequests);
      }
    }
  }, [props]);

  const NextArrow = ({ onClick }) => {
    return myConnectionMore ? (
      <img
        className="arrow-down slick-arrow"
        onClick={onClick}
        src="/assets/images/arrow-down-grey.svg"
        alt=""
        style={{ float: "right", cursor: "pointer" }}
      />
    ) : (
      ""
    );
  };
  const PrevArrow = ({ onClick }) => {
    return myConnectionMore ? (
      <img
        className="arrow-up slick-arrow"
        onClick={onClick}
        src="/assets/images/arrow-up-grey.svg"
        alt=""
        style={{ float: "right", cursor: "pointer" }}
      />
    ) : (
      ""
    );
  };
  const settings = {
    infinite: true,
    dots: false,
    vertical: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    slidesPerRow: 2,
    swipeToSlide: true,
    verticalSwiping: true,
    nextArrow: (
      <div onClick>
        <div
          style={{
            display: "inline-block",
            backgroundColor: "#283270", // Background color of the circle
            borderRadius: "50%", // Makes it a circle
            // width: "40px", // Adjust the size of the circle as needed
            height: "30px", // Adjust the size of the circle as needed
            textAlign: "center",
            lineHeight: "40px", // Vertically centers the icon
            // paddingTop: "5px",
          }}
        >
          <MdOutlineKeyboardArrowDown
            color="white" // Color of the arrow icon
            size={30} // Size of the arrow icon
            cursor="pointer"
          />
        </div>
      </div>
    ),
    prevArrow: (
      <div className="row" onClick>
        <div
          style={{
            display: "inline-block",
            backgroundColor: "#283270", // Background color of the circle
            borderRadius: "50%", // Makes it a circle
            // width: "40px", // Adjust the size of the circle as needed
            height: "30px", // Adjust the size of the circle as needed
            textAlign: "center",
            lineHeight: "40px", // Vertically centers the icon
            float: "right", // Float it to the right as specified
            // paddingTop:'4px'
          }}
        >
          <MdOutlineKeyboardArrowUp
            color="white" // Color of the arrow icon
            size={30} // Size of the arrow icon
            cursor="pointer"
          />
        </div>
      </div>
    ),
  };

  return (
    <div className="row connection-request-section">
      <div className="col-12">
        <h2 className="block-title">Network Requests</h2>
        <div className="border-box">
          <div className="row small-gutter">
            <div className="col-12">
              <div className="border-box-title">
                <label>Please Add Me to Your Network </label>
                {/* <Link to="#" className="more-btn">
                                    {"more"}
                                </Link> */}
              </div>
            </div>
          
            {acceptConnection.length > 0 ? (
  acceptConnection.length > 6 ? (
    <Slider {...settings}>
      {acceptConnection.map((row, index) => (
        <div className="col-sm-6 col-12 cmb-12" key={index}>
          <div className="connect-profile" style={{ display: "flex", alignItems: "center" }}>
            <div className="profile-thumb">
              <div className="hexagon-wrap">
                <HexaImage
                  image={
                    row.profile_pic != null
                      ? IMAGEAPI + row.profile_pic
                      : "/assets/images/no-profile.png"
                  }
                />
              </div>
            </div>
            <div className="profile-content">
              <div className="left-content">
                <Link to={`/user/contact/${row.id}/`}>
                  <div className="name">{row.userId.username}</div>
                </Link>{" "}
                <div className="designition">
                  {row.primary_jobTitle + " - " + row.company_name}
                </div>
                <div className="mutual-connection">{row.mutual_connections} mutual connections</div>
              </div>
            </div>
            <div
              style={{ marginLeft: "auto" }}
            >
              <span className="right-content-pending-requests">
                <Link
                  to=""
                  onClick={() => handleAcceptConnectionChange(index)}
                  className="connect-profile-link"
                >
                  Accept
                </Link>
              </span>&nbsp;
              <span className="right-content-pending-requests">
                <Link
                  to=""
                  onClick={() => handleIgnoreConnectionChange(index)}
                  className="connect-profile-link"
                >
                  Ignore
                </Link>
              </span>
            </div>
            <Link
              to=""
              onClick={() => handleRemoveFormAccept(index)}
              className="remove-block"
            >
              x
            </Link>
          </div>
        </div>
      ))}
    </Slider>
  ) : (
    acceptConnection.map((row, index) => (
      <div className="col-sm-6 col-12 cmb-12" key={index}>
        <div className="connect-profile" style={{ display: "flex", alignItems: "center" }}>
          <div className="profile-thumb">
            <div className="hexagon-wrap">
              <HexaImage
                image={
                  row.profile_pic != null
                    ? IMAGEAPI + row.profile_pic
                    : "/assets/images/no-profile.png"
                }
              />
            </div>
          </div>
          <div className="profile-content">
            <div className="left-content">
              <Link to={`/user/contact/${row.id}/`}>
                <div className="name">{row.userId.username}</div>
              </Link>{" "}
              <div className="designition">
                {row.primary_jobTitle + " - " + row.company_name}
              </div>
              <div className="mutual-connection">{row.mutual_connections} mutual connections</div>
            </div>
          </div>
          <div
            style={{ marginLeft: "auto" }}
          >
            <span className="right-content-pending-requests">
              <Link
                to=""
                onClick={() => handleAcceptConnectionChange(index)}
                className="connect-profile-link"
              >
                Accept
              </Link>
            </span>&nbsp;
            <span className="right-content-pending-requests">
              <Link
                to=""
                onClick={() => handleIgnoreConnectionChange(index)}
                className="connect-profile-link"
              >
                Ignore
              </Link>
            </span>
          </div>
          <Link
            to=""
            onClick={() => handleRemoveFormAccept(index)}
            className="remove-block"
          >
            x
          </Link>
        </div>
      </div>
    ))
  )
) : (
  <div className="col-12">
    <p style={{ textAlign: "left", fontWeight: 600 }}>
      You have no connection requests
    </p>
  </div>
)}
            <div className="col-12 mt-4">
              <div className="border-box-title">
                <label>Your Pending Connection Requests</label>
                {/* <Link to="#" className="more-btn">
                                    {"more"}
                                </Link> */}
              </div>
            </div>
            
            {pendingConnection.length > 0 ? (
  pendingConnection.length > 6 ? (
    <Slider {...settings}>
      {pendingConnection.map((row, index) => (
        <div className="col-sm-6 col-12 cmb-12" key={index}>
          <div className="connect-profile" style={{ display: "flex", alignItems: "center" }}>
            <div className="profile-thumb">
              <div className="hexagon-wrap">
                <HexaImage
                  image={
                    row.profile_pic != null
                      ? IMAGEAPI + row.profile_pic
                      : "/assets/images/no-profile.png"
                  }
                />
              </div>
            </div>
            <div className="profile-content">
              <div className="left-content">
                <Link to={`/user/contact/${row.id}/`}>
                  <div className="name">{row.userId.username}</div>
                </Link>{" "}
                <div className="designition">
                  {row.primary_jobTitle + " - " + row.company_name}
                </div>
                <div className="mutual-connection">{row.mutual_connections} mutual connections</div>
              </div>
            </div>
            <div
              className="right-content-pending-requests"
              style={{ marginLeft: "auto" }}
            >
              <Link
                to=""
                onClick={() => handleWithdrawPendingChange(index, row.id)}
                className="connect-profile-link"
              >
                WithDraw
              </Link>
            </div>
            <Link
              to=""
              onClick={() => handleRemoveFormConnection(index)}
              className="remove-block"
            >
              x
            </Link>
          </div>
        </div>
      ))}
    </Slider>
  ) : (
    pendingConnection.map((row, index) => (
      <div className="col-sm-6 col-12 cmb-12" key={index}>
        <div className="connect-profile" style={{ display: "flex", alignItems: "center" }}>
          <div className="profile-thumb">
            <div className="hexagon-wrap">
              <HexaImage
                image={
                  row.profile_pic != null
                    ? IMAGEAPI + row.profile_pic
                    : "/assets/images/no-profile.png"
                }
              />
            </div>
          </div>
          <div className="profile-content">
            <div className="left-content">
              <Link to={`/user/contact/${row.id}/`}>
                <div className="name">{row.userId.username}</div>
              </Link>{" "}
              <div className="designition">
                {row.primary_jobTitle + " - " + row.company_name}
              </div>
              <div className="mutual-connection">{row.mutual_connections} mutual connections</div>
            </div>
          </div>
          <div
            className="right-content-pending-requests"
            style={{ marginLeft: "auto" }}
          >
            <Link
              to=""
              onClick={() => handleWithdrawPendingChange(index, row.id)}
              className="connect-profile-link"
            >
              WithDraw
            </Link>
          </div>
          <Link
            to=""
            onClick={() => handleRemoveFormConnection(index)}
            className="remove-block"
          >
            x
          </Link>
        </div>
      </div>
    ))
  )
) : (
  <div className="col-12">
    <p style={{ textAlign: "left", fontWeight: 600 }}>
      You have no pending requests
    </p>
  </div>
)}


            <div className="col-12 mt-4">
              <div className="border-box-title">
                <label>Please Accept Profile Request</label>
                {/* <Link to="#" className="more-btn">
                                    {"more"}
                                </Link> */}
              </div>
            </div>
            {acceptProfileConnection.length > 0 ? (
              acceptProfileConnection.map((row, index) => {
                return (
                  <div className="col-sm-6 col-12 cmb-12" key={index}>
                    <div className="connect-profile"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <div className="profile-thumb">
                        <div className="hexagon-wrap">
                          <HexaImage
                            image={
                              row.profile_pic != null
                                ? IMAGEAPI + row.profile_pic
                                : "/assets/images/no-profile.png"
                            }
                          />
                        </div>
                      </div>
                      <div className="profile-content">
                        <div className="left-content">
                          <Link to={`/user/contact/${row.id}/`}>
                            <div className="name">{row.userId.username}</div>
                          </Link>{" "}
                          <div className="designition">
                            {row.primary_jobTitle + " - " + row.company_name}
                          </div>
                          <div className="mutual-connection">
                            {row.mutual_connections} mutual connections
                          </div>
                        </div>
                      </div>
                      <div
                        style={{ marginLeft: "auto" }}
                      >
                      <div className="right-content-pending-requests">
                          <Link
                            to=""
                            onClick={() =>
                              handleAcceptProfileConnectionChange(index)
                            }
                            className="connect-profile-link"
                          >
                            Accept
                          </Link>
                        </div>&nbsp;
                        <div className="right-content-pending-requests">
                          <Link
                            to=""
                            onClick={() =>
                              handleIgnoreProfileConnectionChange(index)
                            }
                            className="connect-profile-link"
                          >
                            Ignore
                          </Link>
                        </div>
                      </div>
                      <Link
                        to=""
                        onClick={() => handleRemoveFormProfileAccept(index)}
                        className="remove-block"
                      >
                        x
                      </Link>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="col-12">
                <p style={{ textAlign: "left", fontWeight: 600 }}>
                  You have no connection requests
                </p>
              </div>
            )}
            <div className="col-12 mt-4">
              <div className="border-box-title">
                <label>Your Pending Profile Requests</label>
                {/* <Link to="#" className="more-btn">
                                    {"more"}
                                </Link> */}
              </div>
            </div>
            {profilePendingConnection.length > 0 ? (
              profilePendingConnection.map((row, index) => {
                return (
                  <div className="col-sm-6 col-12 cmb-12" key={index}>
                    <div
                      className="connect-profile"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <div className="profile-thumb">
                        <div className="hexagon-wrap">
                          <HexaImage
                            image={
                              row.profile_pic != null
                                ? IMAGEAPI + row.profile_pic
                                : "/assets/images/no-profile.png"
                            }
                          />
                        </div>
                      </div>
                      <div className="profile-content">
                        <div className="left-content">
                          <Link to={`/user/contact/${row.id}/`}>
                            <div className="name">{row.userId.username}</div>
                          </Link>{" "}
                          <div className="designition">
                            {row.primary_jobTitle + " - " + row.company_name}
                          </div>
                          <div className="mutual-connection">
                            {row.mutual_connections} mutual connections
                          </div>
                        </div>
                      </div>
                      <div
                        className="right-content-profession-req"
                        style={{ marginLeft: "auto", color: "red" }}
                      >
                        <button
                          onClick={() =>
                            handleWithdrawProfilePendingChange(index)
                          }
                          className="connect-profile-link"
                        >
                          WithDraw
                        </button>
                      </div>
                      <Link
                        to=""
                        onClick={() => handleRemoveFormProfile(index)}
                        className="remove-block"
                      >
                        x
                      </Link>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="col-12">
                <p style={{ textAlign: "left", fontWeight: 600 }}>
                  You have no pending requests
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;
  const profile = state.user.profile;
  const acceptConectionRequests = state.network.acceptConectionRequests;
  const pendingConnectionRequests = state.network.pendingConnectionRequests;
  const pendingProfileRequests = state.network.pendingProfileRequests;
  const acceptProfileConectionRequests =
    state.network.acceptProfileConectionRequests;
  return {
    user: user,
    profile: profile,
    acceptConectionRequests: acceptConectionRequests,
    pendingConnectionRequests: pendingConnectionRequests,
    pendingProfileRequests: pendingProfileRequests,
    acceptProfileConectionRequests: acceptProfileConectionRequests,
  };
};

const mapDispatchToProps = (dispatch, state) => {
  return {
    fetchAcceptConnectionRequests: (profileId) =>
      dispatch(fetchAcceptConnectionRequestsAction(profileId)),
    fetchPendingConnectionRequests: (profileId) =>
      dispatch(fetchPendingConnectionRequestsAction(profileId)),
    fetchPendingProfileRequests: () =>
      dispatch(fetchPendingProfileRequestsAction()),

    withdrawPendingConnection: (receiver, data) =>
      dispatch(withDrawPedingConnectionAction(receiver, data)),
    acceptConnectionRequest: (requestId, connection) =>
      dispatch(acceptConnectionRequestAction(requestId, connection)),
    ignoreConnectionRequest: (request, connection) =>
      dispatch(ignoreConnectionRequestAction(request, connection)),

    fetchAcceptProfileConnections: (profileId) =>
      dispatch(fetchPendingProfileConnectionsAction(profileId)),
    withdrawProfilePendingConnection: (id, data) =>
      dispatch(withDrawProfileConnectionAction(id, data)),

    acceptProfileConnectionRequest: (id, connection) =>
      dispatch(acceptProfileConnectionAction(id, connection)),
    ignoreProfileConnectionRequest: (data, connection) =>
      dispatch(ignoreProfileConnectionAction(data, connection)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConnectionRequests)